import React from 'react';
import { ArrowLeft, Moon, Globe, Shield, HelpCircle, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Settings() {
  const navigate = useNavigate();
  const items = [{
    icon: Moon,
    label: 'Tema',
    value: 'Oscuro'
  }, {
    icon: Globe,
    label: 'Idioma',
    value: 'Español'
  }, {
    icon: Shield,
    label: 'Privacidad'
  }, {
    icon: HelpCircle,
    label: 'Ayuda'
  }, {
    icon: Info,
    label: 'Acerca de BarberOS',
    value: 'v1.0.0'
  }];
  return <div className="min-h-screen bg-dark flex flex-col" data-id="element-1059">
      <header className="p-6 flex items-center gap-4 border-b border-white/5" data-id="element-1060">
        <button onClick={() => navigate(-1)} className="text-light hover:text-gold" data-id="element-1061">
          <ArrowLeft size={24} data-id="element-1062" />
        </button>
        <h2 className="text-lg font-medium text-light" data-id="element-1063">Configuración</h2>
      </header>
      <div className="p-6 space-y-2" data-id="element-1064">
        {items.map((item, i) => <div key={i} className="flex items-center justify-between p-4 bg-dark-card rounded-2xl border border-white/5" data-id="element-1065">
            <div className="flex items-center gap-3 text-light" data-id="element-1066">
              <item.icon size={20} className="text-light-muted" data-id="element-1067" />
              <span className="text-sm font-medium" data-id="element-1068">{item.label}</span>
            </div>
            {item.value && <span className="text-xs text-light-muted" data-id="element-1069">{item.value}</span>}
          </div>)}
      </div>
    </div>;
}